module.exports = __webpack_public_path__ + "static/media/Yatogame2.6d03d225.png";